import { render, staticRenderFns } from "./StationMail.vue?vue&type=template&id=578fd860&scoped=true"
import script from "./StationMail.vue?vue&type=script&lang=js"
export * from "./StationMail.vue?vue&type=script&lang=js"
import style0 from "./StationMail.vue?vue&type=style&index=0&id=578fd860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fd860",
  null
  
)

export default component.exports